<template>
  <div
    class="query"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-background="rgba(255, 255, 255, 1)"
  >
    <!-- 顶部组件 -->
    <top-navigation :loginDialog="loginDialog" @loginClose="loginClose"></top-navigation>
    <!-- 弹窗遮罩 -->
    <div class="mask" v-if="maskType"></div>
    <!-- 顶部 -->
    <!-- 搜索/浏览/访问 -->
    <div class="query_bgc">
        <div class="query_seach mt">
            <div class="_searchKong"></div>
            <div class="_seachLeft">
                <el-input v-model="seachList.fuzzyQuery" placeholder="请输入您要查找的品牌信息，如茅台或酒类"
                    @keydown.enter.native="query"></el-input>
                <div class="_searchBtn" @click="query">
                    <img src="../../assets/image/query/search_0310.png" alt="">
                </div>
            </div>
            <div class="_seachRight">
                <div class="right_icon">
                    <img class="liulan" src="../../assets/image/query/liulanliang.png" alt="">
                    <span>浏览量：{{ 30000 + visitVrowse.pageViews}}</span>
                </div>
                <div class="right_icon">
                    <img class="fangwen" src="../../assets/image/query/fangwenliang.png" alt="">
                    <span>访问量：{{ 10000 + visitVrowse.visitors}}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- 数据表格 -->
    <div class="query_tabs mt" id="centBox">
        <div class="_tabsLeft" ref="container">
            <div class="_tabsTitle">分类筛选</div>
            <div class="_tabsTopBox" style="height:780px">
                <div class="topBox_title">选择地区</div>
                <!-- 国家 -->
                <div class="topBox_inp" style="top: 53px;" :style="global ? 'z-index:999':''">
                    <el-input v-model="globalInput" placeholder="国家（全部）"></el-input>
                    <img v-if="global == false"
                        @click="maskType=true,global=true,province=false,acquisitionTime=false,industryOne=false,sort=false,label=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="global = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <!-- 省/市 -->
                <div class="topBox_inp" style="top: 100px;" :style="province ? 'z-index:999':''">
                    <el-input v-model="provinceInput" placeholder="省/市（全部）" v-if="globalCode == '100000'"></el-input>
                    <el-input  v-model="provinceInput" :disabled="true" placeholder="————" v-else></el-input>
                    <img v-if="province == false && globalCode == '100000'"
                        @click="maskType=true,province=true,global=false,acquisitionTime=false,industryOne=false,sort=false,label=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="province = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <div class="topBox_title" style="top: 147px;">选择时间</div>
                <!-- 时间 -->
                <div class="topBox_radio" style="top: 175px">
                    <el-radio v-model="seachList.selectTimeType" label="0">自定义时间</el-radio>
                    <el-radio v-model="seachList.selectTimeType" label="1">时间段</el-radio>
                </div>
                <div class="topBox_inp" style="top: 205px;" v-if="seachList.selectTimeType == 0" :style="acquisitionTime ? 'z-index:999':''">
                    <el-input v-model="yearInput" placeholder="全部"></el-input>
                    <img v-if="acquisitionTime == false"
                        @click="maskType=true,acquisitionTime=true,global=false,province=false,industryOne=false,sort=false,label=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="acquisitionTime = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <div class="topBox_radioTime" style="top: 205px;" v-if="seachList.selectTimeType == 1" :style="acquisitionTime ? 'z-index:999':''">
                    <el-date-picker
                        v-model="seachList.scopeTimeStart"
                        type="month"
                        style="width: 95px;"
                        value-format="yyyy-MM"
                        placeholder="">
                    </el-date-picker>
                    <span style="float: left;margin: 7px 10px;">至</span>
                    <el-date-picker
                        v-model="seachList.scopeTimeEnd"
                        type="month"
                        style="width: 95px;"
                        value-format="yyyy-MM"
                        placeholder="">
                    </el-date-picker>
                </div>
                <div class="topBox_type" style="top: 227px;">选择行业</div>
                <!-- 行业 -->
                <div class="topBox_inp" style="top: 277px;" :style="industryOne ? 'z-index:999':''">
                    <el-input v-model="oneIndusInput" placeholder="行业（全部）"></el-input>
                    <img v-if="industryOne == false"
                        @click="maskType=true,industryOne=true,global=false,province=false,acquisitionTime=false,sort=false,label=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="industryOne = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <!-- 标签 -->
                <div class="topBox_type" style="top: 300px;">选择标签</div>
                <div class="topBox_inp" style="top: 350px;" :style="label ? 'z-index:999':''">
                    <el-input v-model="labelInput" placeholder="全部"></el-input>
                    <img v-if="label == false"
                        @click="maskType=true,label=true,sort=false,industryOne=false,global=false,province=false,acquisitionTime=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="label = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <div class="topBox_type" style="top: 375px;">选择排序方式</div>
                <!-- 排序 -->
                <div class="topBox_inp" style="top: 425px;" :style="sort ? 'z-index:999':''">
                    <el-input v-model="sortInput" placeholder="选择排序"></el-input>
                    <img v-if="sort == false"
                        @click="maskType=true,sort=true,industryOne=false,global=false,province=false,acquisitionTime=false,label=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                    <img v-else class="close" @click="sort = false,maskType=false"
                        src="../../assets/image/query/arrow_down.png" alt="">
                </div>
                <!-- 确认/重置 -->
                <div class="topBox_sub" style="bottom: 280px;">
                    <el-button style="width: 100px;margin-right: 6px;" size="mini" @click="reset()">重 置</el-button>
                    <el-button style="width: 100px;" size="mini" type="primary" @click="query()">查 询</el-button>
                </div>
                <!-- 注 -->
                <div class="topBox_zhu" style="bottom:5px;">
                    <div class="_zhuTips">重要提示</div>
                    <div class="_zhuList">
                        <ol>
                            <li><a target="view_window"
                                    href="https://zhuowen.oss-cn-beijing.aliyuncs.com/file/GB39071-2020.pdf">
                                    美誉度、忠诚度、认知度、知名度等名词释义详见国标：<br>
                                    国标名：品牌评价 消费者感知测量指南<br>
                                    国标号：GB/T 39071-2020<br>
                                    <span style="color:#0087FA;">点击查看标准原版</span>
                                </a></li>
                            <!-- <li><a target="view_window"
                                    href="https://zhuowen.oss-cn-beijing.aliyuncs.com/file/GB39869-2021.pdf">国标名：品牌评价旅游目的地<br>
                                    国标号：GB/T 39869-2021</a></li> -->
                            <li>
                              <div class="_tabsUp">
                                  使用本网站数据应注明数据来源与出处：卓闻数据 · 全球品牌数据库。公司官网：www.zhuowendata.com <br>
                                  登录日期：{{timeLogin}} <br>
                              </div>
                              <div class="_zhuTishi" style="color:#0087FA;" @click="getCopy">点击复制用于参考文献</div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

            <!-- 新选项弹窗模板 -->
            <!-- <div class="_seltDialog">
                <div class="_jiao"></div>
                <div class="_diaSeach">
                    <el-input v-model="globalInput" placeholder="输入关键词搜索"></el-input>
                    <div class="_searchBtn" @click="see">
                        <img src="../../assets/image/query/search_0310.png" alt="">
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft">
                        <div class="_leftTitle">选择省市：</div>
                        <div class="_leftBox">
                            <div class="_leftOneFloor">
                                <img src="../../assets/image/query/arrow_down.png" alt="">
                                <span>全国（含港澳台）</span>
                                <div class="_leftTweFloor">
                                    <img src="../../assets/image/query/arrow_down.png" alt="">
                                    <span>主要省市</span>
                                    <div class="_leftTreeFloor">
                                        <div style="margin-bottom: 6px;" v-for="item in 16">
                                            <div class="_changeBox">
                                                <i class="el-icon-check"></i>
                                            </div>
                                            <span>安徽</span>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="_diaRight">
                        <div class="_leftTitle">已选省市：</div>
                        <div class="_rightOneFloor">
                            <div class="floorTitle">港、澳、台地区（2）</div>
                            <div class="_rightTweFloor">
                                <div style="margin-bottom:10px;" v-for="item in 8">
                                    <div class="floorTitle">澳门 <i class="el-icon-close"></i></div>
                                </div>
                            </div>
                        </div>
                        <div class="_rightBtn">
                            <el-button type="primary" plain>重 置</el-button>
                            <el-button type="primary">确 定</el-button>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 全国弹框 -->
            <div class="_seltDialog" v-if="global" style="width: 410px;" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:56px;"></div>
                <!-- 搜索 -->
                <div class="_diaSeach">
                    <el-input v-model="seachGlobal.countryName" placeholder="输入关键词搜索"
                        @keydown.enter.native="queryGlobal"></el-input>
                    <div class="_searchBtn" @click="queryGlobal">
                        <img src="../../assets/image/query/search_0310.png" alt="">
                    </div>
                    <div class="closeIcon" @click="global = false,maskType=false">
                        <img src="../../assets/image//query/guanbi.png" alt="">
                    </div>
                    <!-- 重置/确认 -->
                    <div class="_rightBtn">
                        <el-button size="medium" plain @click="resetGlobalData"
                            style="margin-left: 15px;">重 置</el-button>
                        <!-- <el-button size="medium" type="primary" @click="subGlobalData">确 定</el-button> -->
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft">
                        <!-- <div class="_leftTitle">
                            <span>选择国家：</span>
                            <el-button size="mini" plain style="float: right;margin-left: 8px;"
                                @click="allClearGlobal()">清 除</el-button>
                            <el-button style="float: right;margin-left: 5px;" size="mini" type="primary"
                                @click="allCheckGlobal()">全 选</el-button>
                        </div> -->
                        <!-- 全国 -->
                        <div class="rollBox">
                            <div class="_leftBox">
                                <div class="_leftOneFloor" v-if="globalData.length > 0">
                                    <div style="margin-bottom:6px;" v-for="(item,index) in globalData" :key="index">
                                        <div class="_changeBox" @click="choiceGlobal(item)">
                                            <i v-if="item.name == globalInput" class="el-icon-check"></i>
                                        </div>
                                        <span style="width: 200px;">{{item.name}}</span>
                                    </div>
                                </div>
                                <div v-else class="tips">暂无查询结果</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="_diaRight">
                        <div class="_leftTitle">已选国家：({{changeGlobalData.length}})</div>
                        <div class="rollBox">
                            <div class="_rightOneFloor">
                                <div class="_rightTweFloor" style="margin-left: 0;">
                                    <div style="margin-bottom:10px;" v-for="(item,index) in changeGlobalData"
                                        :key="index">
                                        <div class="floorTitle">{{item.name}}<i @click="choiceGlobal(item)"
                                                class="el-icon-close"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- 省弹框 -->
            <div class="_seltDialog" v-if="province" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:107px;"></div>
                <div class="_diaSeach">
                    <el-input v-model="seachProvince.fuzzyQuery" placeholder="输入关键词搜索"
                        @keydown.enter.native="queryProvince"></el-input>
                    <div class="_searchBtn" @click="queryProvince">
                        <img src="../../assets/image/query/search_0310.png" alt="">
                    </div>
                    <div class="closeIcon" @click="province = false,maskType=false">
                        <img src="../../assets/image//query/guanbi.png" alt="">
                    </div>
                    <!-- 确定/重置 -->
                    <div class="_rightBtn">
                        <el-button size="medium" plain @click="resetProvinceData"
                            style="margin-left: 15px;">重 置</el-button>
                        <el-button size="medium" type="primary" @click="subProvinceData">确 定</el-button>
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft" style="flex: 1.5;">
                        <div class="_leftTitle">
                            <span>选择省/市：</span>
                        </div>
                        <div class="rollBox">
                            <div v-if="provinceData.child.length > 0">
                                <div class="_leftBox">
                                    <div class="_leftOneFloor" style="margin-bottom: 15px;">
                                        <img src="../../assets/image/query/arrow_down.png" alt="" v-if="provinceData.choice == true"
                                            @click="opPrimary(provinceData)">
                                        <img class="closeActive" src="../../assets/image/query/arrow_down.png" v-else alt=""
                                            @click="opPrimary(provinceData)">
                                        <div class="_changeBox" @click="allChoiceProvince(provinceData)">
                                            <i v-if="provinceData.allChoice" class="el-icon-check"></i>
                                        </div>
                                        <span>{{provinceData.name}}</span>
                                        <div class="_leftTreeFloor" style="margin: 10px 0 0 54px;" v-show="provinceData.choice">
                                            <div style="margin-bottom: 6px;" v-for="(em,it) in provinceData.child" :key="it">
                                                <div class="_leftOneFloor">
                                                    <img src="../../assets/image/query/arrow_down.png" v-show="em.subInfos" alt="" v-if="em.choice == true"
                                                        @click="opPrimary(em)">
                                                    <img class="closeActive" src="../../assets/image/query/arrow_down.png" v-show="em.subInfos" v-else alt=""
                                                        @click="opPrimary(em)">
                                                    <span style="width: 24px;height: 24px;" v-show="!em.subInfos"></span>
                                                    <div class="_changeBox" @click="allChoiceProvinceTwe(em)">
                                                        <i v-if="em.allChoice" class="el-icon-check"></i>
                                                    </div>
                                                    <span>{{em.name}}</span>
                                                    <div class="_leftTreeFloor" style="margin: 5px 0 0 54px;" v-show="em.choice" v-if="em.subInfos">
                                                        <div style="margin-bottom: 6px;" v-for="(item,index) in em.subInfos" :key="index">
                                                            <div class="_changeBox" @click="choiceProvince(item)">
                                                                <i v-if="item.choice" class="el-icon-check"></i>
                                                            </div>
                                                            <span>{{item.name}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="tips">暂无查询结果</div>
                        </div>
                    </div>
                    <div class="_diaRight">
                        <div class="_leftTitle">已选省/市：</div>
                        <div class="rollBox">
                            <div class="_rightOneFloor">
                                <div v-for="(item,index) in changeProvinceData" :key="index">
                                    <div class="floorTitle" style="margin-bottom: 5px;">{{item.name}}<i
                                            class="el-icon-close" @click="choiceProvince(item)"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 采集时间弹框 -->
            <div class="_seltDialog" v-if="acquisitionTime" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:210px;"></div>
                <!-- 搜索 -->
                <div class="_diaSeach">
                    <span class="_title">输入时间:</span>
                    <el-date-picker
                        v-model="seachTime.fuzzyQuery"
                        type="month"
                        style="width: 120px;"
                        value-format="yyyy-MM"
                        placeholder="">
                    </el-date-picker>
                    <!-- 查询 -->
                    <el-button style="float: left;margin-left: 5px;" size="medium" type="primary"
                        @click="queryTime">查 询</el-button>
                    <!-- 关闭 -->
                    <div class="closeIcon" @click="acquisitionTime = false,maskType=false">
                        <img src="../../assets/image//query/guanbi.png" alt="">
                    </div>
                    <!-- 确定/重置 -->
                    <div class="_rightBtn">
                        <el-button size="medium" plain @click="resetTimeData"
                            style="margin-left: 8px;">重 置</el-button>
                        <el-button style="margin: 0;" size="medium" type="primary" @click="subTimeData">确 定
                        </el-button>
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft">
                        <div class="_leftTitle">
                            <span style="float: left;">选择时间：</span>
                            <el-button size="mini" plain style="float: right;margin-left: 8px;"
                                @click="allClearTime()">清 除</el-button>
                            <el-button style="float: right;margin-left: 5px;" size="mini" type="primary"
                                @click="allCheckTime()">全 选</el-button>
                        </div>
                        <div class="rollBox">
                            <div class="_leftBox">
                                <!-- 年份 -->
                                <div class="_leftOneFloor" v-if="yearData[0].child.length > 0">
                                    <div style="margin-bottom:6px;" v-for="(item,index) in yearData" :key="index">
                                        <img src="../../assets/image/query/arrow_down.png" alt="" v-if="item.choice"
                                            @click="openTimeClose(item)">
                                        <img class="closeActive" src="../../assets/image/query/arrow_down.png" v-else alt=""
                                            @click="openTimeClose(item)">
                                        <div class="_changeBox" @click="allChoiceTime(item)">
                                            <i v-if="item.allChoice" class="el-icon-check"></i>
                                        </div>
                                        <span>{{item.name}}</span>
                                        <div class="_leftTreeFloor" style="margin: 10px 0 0 55px;"
                                            v-show="item.choice">
                                            <div style="margin-bottom: 6px;" v-for="(it,int) in item.child"
                                                :key="int">
                                                <div class="_changeBox" @click="choiceTime(it)">
                                                    <i v-if="it.choice" class="el-icon-check"></i>
                                                </div>
                                                <span>{{it.name}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="tips">暂无查询结果</div>
                            </div>
                        </div>
                    </div>
                    <div class="_diaRight">
                        <div class="_leftTitle">已选时间：({{changeTimeData.years.length +
                            changeTimeData.quarters.length + changeTimeData.months.length}})</div>
                        <div class="rollBox">
                            <div class="_rightOneFloor">
                                <div class="_rightTweFloor" style="margin-left: 0;">
                                    <div style="margin-bottom:10px;" v-for="(item,index) in changeTimeData.years"
                                        :key="index">
                                        <div class="floorTitle">{{item.name}}<i @click="choiceTime(item)"
                                                class="el-icon-close"></i></div>
                                    </div>
                                    <div style="margin-bottom:10px;" v-for="(item,index) in changeTimeData.quarters"
                                        :key="index + '1'">
                                        <div class="floorTitle">{{item.name}}<i @click="choiceTime(item)"
                                                class="el-icon-close"></i></div>
                                    </div>
                                    <div style="margin-bottom:10px;" v-for="(item,index) in changeTimeData.months"
                                        :key="index + '2'">
                                        <div class="floorTitle">{{item.name}}<i @click="choiceTime(item)"
                                                class="el-icon-close"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 行业一级弹框 -->
            <div class="_seltDialog" v-if="industryOne" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:282px;"></div>
                <!-- 搜索 -->
                <div class="_diaSeach">
                    <el-input v-model="seachOneIndustry.fuzzyQuery" placeholder="输入关键词搜索" style="width: 200px;"
                        @keydown.enter.native="queryOneIndustry"></el-input>
                    <div class="_searchBtn" @click="queryOneIndustry">
                        <img src="../../assets/image/query/search_0310.png" alt="">
                    </div>
                    <div class="closeIcon" @click="industryOne = false,maskType=false">
                        <img src="../../assets/image//query/guanbi.png" alt="">
                    </div>
                    <!-- 确定/重置 -->
                    <div class="_rightBtn">
                        <el-button size="medium" plain @click="resetOneIndustryData"
                            style="margin-left: 15px;">重 置</el-button>
                        <el-button size="medium" type="primary" @click="subOneIndustryData">确 定</el-button>
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft">
                        <div class="_leftTitle">
                            <span>选择行业：</span>
                            <el-button size="mini" plain style="float: right;margin-left: 8px;"
                                @click="allClearIndustry()">清 除</el-button>
                            <el-button style="float: right;margin-left: 5px;" size="mini" type="primary"
                                @click="allCheckIndustry()">全 选</el-button>
                        </div>
                        <!-- 全国 -->
                        <div class="rollBox">
                            <div class="_leftBox">
                                <div class="_leftOneFloor" v-if="oneIndustryData.length > 0">
                                    <div style="margin-bottom:6px;" v-for="(item,index) in oneIndustryData"
                                        :key="index">
                                        <img src="../../assets/image/query/arrow_down.png" v-if="item.choice" alt=""
                                            @click="openIndustryClose(item)">
                                        <img class="closeActive" src="../../assets/image/query/arrow_down.png" v-else alt=""
                                            @click="openIndustryClose(item)">
                                        <div class="_changeBox" @click="allChoiceOneIndustry(item)">
                                            <i v-show="item.allChoice" class="el-icon-check"></i>
                                        </div>
                                        <span>{{item.typeName}}</span>
                                        <div class="_leftTreeFloor" style="margin: 10px 0 0 55px;"
                                            v-if="item.choice">
                                            <div style="margin-bottom: 6px;"
                                                v-for="(it,int) in item.subIndustryList" :key="int">
                                                <div class="_changeBox" @click="choiceOneIndustry(it)">
                                                    <i v-if="it.choice" class="el-icon-check"></i>
                                                </div>
                                                <span>{{it.typeName}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="tips">暂无查询结果</div>
                            </div>
                        </div>
                    </div>
                    <div class="_diaRight">
                        <div class="_leftTitle">已选行业：({{changeOneIndustryData.length}})</div>
                        <div class="rollBox">
                            <div class="_rightOneFloor">
                                <div class="_rightTweFloor" style="margin-left: 0;">
                                    <div style="margin-bottom:10px;" v-for="(item,index) in changeOneIndustryData"
                                        :key="index">
                                        <div class="floorTitle">{{item.typeName}}<i @click="choiceOneIndustry(item)"
                                                class="el-icon-close"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 标签弹窗 -->
            <div class="_seltDialog" v-if="label" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:356px;"></div>
                <div class="_diaSeach">
                    <el-input v-model="seachLabel.fuzzyQuery" placeholder="输入关键词搜索"
                        @keydown.enter.native="queryLabel"></el-input>
                    <div class="_searchBtn" @click="queryLabel">
                        <img src="../../assets/image/query/search_0310.png" alt="">
                    </div>
                    <div class="closeIcon" @click="label= false,maskType=false">
                        <img src="../../assets/image//query/guanbi.png" alt="">
                    </div>
                    <!-- 确定/重置 -->
                    <div class="_rightBtn">
                        <el-button size="medium" plain @click="resetLabelData"
                            style="margin-left: 15px;">重 置</el-button>
                        <el-button size="medium" type="primary" @click="subLabelData">确 定</el-button>
                    </div>
                </div>
                <div class="_diaSeachBox">
                    <div class="_diaLeft" style="flex: 1.5;">
                        <div class="_leftTitle">
                            <span>选择标签：</span>
                        </div>
                        <div class="rollBox">
                            <div v-if="labelData.length > 0">
                                <div class="_leftBox">
                                    <div class="_leftOneFloor" style="margin-bottom: 8px;" v-for="(item,index) in labelData" :key="index">
                                        <div class="_changeBox" @click="choiceLabel(item)">
                                            <i v-if="item.choice" class="el-icon-check"></i>
                                        </div>
                                        <span>{{item.labelName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="tips">暂无查询结果</div>
                        </div>
                    </div>
                    <div class="_diaRight">
                        <div class="_leftTitle">已选标签：</div>
                        <div class="rollBox">
                            <div class="_rightOneFloor">
                                <div v-for="(item,index) in changeLabelData" :key="index">
                                    <div class="floorTitle" style="margin-bottom: 5px;">{{item.labelName}}<i
                                        class="el-icon-close" @click="choiceLabel(item)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 排序弹窗 -->
            <div class="_seltDialog" v-if="sort" style="width: 350px;height: 300px;top: 360px;" :style="maskType ? 'z-index:999':''">
                <div class="_jiao" style="top:103px;"></div>
                <div class="_diaSeachBox" style="margin-top: 0;">
                    <div class="_diaLeft">
                        <div class="_leftTitle">
                            <span>选择排序方式：</span>
                            <div class="closeIcon" style="float: right;" @click="sort = false,maskType=false">
                                <img src="../../assets/image//query/guanbi.png" alt="">
                            </div>
                        </div>
                        <!-- 全国 -->
                        <div class="_leftBox">
                            <div class="_leftOneFloor">
                                <div style="margin-bottom:6px;" v-for="(item,index) in sortData" :key="index">
                                    <div class="_changeBox" @click="choiceSort(item)">
                                        <i v-if="item.name == sortInput" class="el-icon-check"></i>
                                    </div>
                                    <span style="width: 200px;">{{item.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="_tabsRight" id="tab">
            <!-- 表头 -->
            <div class="_tabsTop">
                <div class="_tabsChioce" @click="allChangeTable()">
                    <div class="_changeBox">
                        <i v-if="allTable == true" class="el-icon-check"></i>
                    </div>
                    <span> 本页全选 </span>
                </div>
                <div class="_tabsIndex" style="width: 0px;"></div>
                <ul>
                    <li>品牌名称</li>
                    <li>行业</li>
                    <li>地区</li>
                    <li>采集时间及范围</li>
                    <li @click="changeInformation()" style="cursor: pointer;">信息总量(万比特)
                        <!-- <div>
                            <icon class="el-icon-caret-top" :class="[information == 1 ? 'upIcon':'']"></icon>
                            <icon class="el-icon-caret-bottom" :class="[information == 0 ? 'downIcon':'']">
                            </icon>
                        </div> -->
                    </li>
                    <li @click="changePopularity()" style="cursor: pointer;">知名度(%)
                        <!-- <div>
                            <icon class="el-icon-caret-top" :class="[popularity == 1 ? 'upIcon':'']"></icon>
                            <icon class="el-icon-caret-bottom" :class="[popularity == 0 ? 'downIcon':'']">
                            </icon>
                        </div> -->
                    </li>
                    <li @click="changeAwareness()" style="cursor: pointer;">认知度(%)
                        <!-- <div>
                            <icon class="el-icon-caret-top" :class="[awareness == 1 ? 'upIcon':'']"></icon>
                            <icon class="el-icon-caret-bottom" :class="[awareness == 0 ? 'downIcon':'']"></icon>
                        </div> -->
                    </li>
                    <li @click="changeReputation" style="cursor: pointer;">美誉度(%)
                        <!-- <div>
                            <icon class="el-icon-caret-top" :class="[reputation == 1 ? 'upIcon':'']"></icon>
                            <icon class="el-icon-caret-bottom" :class="[reputation == 0 ? 'downIcon':'']">
                            </icon>
                        </div> -->
                    </li>
                    <li @click="changeLoyalty" style="cursor: pointer;">忠诚度(%)
                        <!-- <div>
                            <icon class="el-icon-caret-top" :class="[loyalty == 1 ? 'upIcon':'']"></icon>
                            <icon class="el-icon-caret-bottom" :class="[loyalty == 0 ? 'downIcon':'']"></icon>
                        </div> -->
                    </li>
                    <li>品牌标签</li>
                    <!-- <li>品牌价值</li> -->
                </ul>
                <div class="_tabsBtn"></div>
            </div>
            <!-- 空页面 -->
            <div class="_kongbai" v-if="tableData.length == 0">
                <div class="_kong">
                    <img src="../../assets/image/query/kongbai.png" alt="">
                    <div>当前暂无内容</div>
                </div>
            </div>
            <!-- 表格 -->
            <div class="_tabsbottom" v-else v-for="(item,index) in tableData" :key="index"
                >
                <div class="_tabsChioce" @click="choiceTable(item)">
                    <div class="_changeBox">
                        <i v-if="item.choice" class="el-icon-check"></i>
                    </div>
                </div>
                <div class="_tabsIndex" @click="goDetail(item)">{{ ((pageNum - 1) * pageSize) + index + 1}}</div>
                <ul @click="goDetail(item)">
                    <li>{{item.companyName}}</li>
                    <li>{{item.industryName}}-{{item.subIndustryName}}</li>
                    <li v-if="item.regionStr">{{item.regionStr}}</li>
                    <li v-else>--</li>
                    <li v-if="item.collectionTime && item.targetStatus == '0'">{{item.collectionTime}} 全国</li>
                    <li v-else-if="item.collectionTime && item.targetStatus == '1'">{{item.collectionTime}} 指定范围</li>
                    <li v-else>--</li>
                    <li v-if="item.information">{{item.information}}</li>
                    <li v-else>--</li>
                    <li v-if="item.popularity">{{item.popularity}}</li>
                    <li v-else>--</li>
                    <li v-if="item.awareness">{{item.awareness}}</li>
                    <li v-else>--</li>
                    <li v-if="item.reputation">{{item.reputation}}</li>
                    <li v-else>--</li>
                    <li v-if="item.loyalty">{{item.loyalty}}</li>
                    <li v-else>--</li>
                    <li v-if="item.allLabelName">
                      <el-tooltip placement="top">
                        <div slot="content" style="width:100px;text-align: center;" v-for="(item,index) in item.allLabelName" :key="index">
                          <!-- <span><br/></span> -->{{item}}
                        </div>
                        <span>{{item.allLabelName[0]}}</span>
                      </el-tooltip>
                    </li>
                    <!-- <li v-if="item.brandValue">{{item.brandValue}}</li> -->
                    <li v-else>--</li>
                </ul>
                <div @click="goDetail(item)" class="_tabsBtn">查看报告</div>
            </div>
            <!-- 分页 -->
            <div id="one" style="overflow:hidden;">
                <!-- <div class="query_page"> -->
                <div :class="isFixed ? 'query_page' : 'page_active'"
                    :style="{'width' : (isFixed ? '100%' : scrollWidth + 'px')}"
                >
                    <div class="query_export" v-if="tableData.length > 0">
                        <div class="export" @click="updownExce()">
                            <img src="../../assets/image/query/down.png" alt="">
                            <span>批量下载数据</span>
                        </div>
                        <!-- <div class="export" @click="updownWord()">
                            <img src="../../assets/image/query/down.png" alt="">
                            <span>批量下载报告</span>
                        </div> -->
                        <div class="exportChange" v-if="changeTableData.length != 0">已选择{{changeTableData.length}}个品牌</div>
                    </div>
                    <el-pagination class="msg-pagination-container" :background="isBackground" next-text="下一页" layout="pager, next"
                        @current-change="handleCurrentChange" :page-size="seachList.pageSize"
                        :current-page.sync="seachList.pageNum" :total="total">
                    </el-pagination>
                </div>
            </div>
            <div class="_tabsBottomBox">
                <div class="_tabsBottom">
                    本网站数据版权属于“北京卓闻数据科技有限公司”所有（如下简称卓闻数据），卓闻数据支持全国的企业、高校、科研机构的研究者免费使用，但请在使用时务必注明出处，以示您对知识产权创新的尊重。
                </div>
                <div class="_tabsBottom">
                    本网站提供的主界面数据都是中国大陆消费者对品牌的认知情况，只反映中国大陆消费者的指标。
                </div>
            </div>
        </div>
    </div>
    <!-- 底部 -->
    <div class="query_footer">
        <div class="footerBox mt">
            <div class="footer_img">
                <img src="../../assets/image/query/logo_bottom.png" alt="">
            </div>
            <div class="footer_conter">
                <div class="_conterTop">合作单位</div>
                <div class="_conterCet">
                    <ul>
                        <li><a href="#">中国品牌发展公益基金</a></li>
                        <li><a href="#">中国质量协会</a></li>
                        <li><a href="#">中国商业史学会</a></li>
                        <li><a href="#">深圳市零售商业行业协会</a></li>
                        <li><a href="#">北方工业大学</a></li>
                        <li><a href="#">首都经济贸易大学中国品牌研究中心</a></li>
                        <li><a href="#">对外经济贸易大学奢侈品研究中心</a></li>
                        <li><a href="#">深圳市连锁经营协会</a></li>
                        <li><a href="#">《品牌研究》杂志社</a></li>
                        <li><a href="#">《品质》杂志社</a></li>
                        <li><a href="#">北京国信品牌评价科学研究院</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer_right">
                <div>座机:<span> 010-88801917</span></div>
                <div>手机:<span> 周先生 13146926876</span></div>
                <div>地址: 北京市石景山区实兴大街30号院7号楼8层88号</div>
                <div>网址: www.zhuowendata.com</div>
                <div>京ICP备2021000793号-1</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Footer from "../../components/footer/footer.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import { getToken } from "@/utils/auth.js";

export default {
  components: { topNavigation, Footer },
  data() {
    return {
      isBackground: true, // 分页颜色
      url:
        location.host == "www.zhuowendata.com"
          ? "https://www.zhuowendata.com"
          : "https://dev.quickbusiness.cn",
      // information: -1,  // 信息总量
      // popularity: -1, // 知名度
      // awareness: -1,    // 认知度
      // reputation: -1,   // 美誉度
      // loyalty: -1,  // 忠诚度
      visitVrowse: "", // 访问浏览
      seachList: {
        // awarenessSort: '',      // 认知度 排序,0:降序, 1:升序
        // brandValueSort: '',     // 品牌价值 排序,0:降序, 1:升序
        // popularitySort: '',     // 知名度 排序,0:降序, 1:升序
        // reputationSort: '',     // 美誉度 排序,0:降序, 1:升序
        // informationSort: '',    // 信息总量/万比特 排序,0:降序, 1:升序
        // loyaltySort: '',        // 忠诚度 排序,0:降序, 1:升序

        brandLabels: [], // 所选的多个品牌标签
        fuzzyQuery: "", // 品牌查询,品牌名
        codes: ["100000"], // 地区编码
        pageNum: 1, // 页码
        pageSize: 15, // 每页条数
        subIndustryValues: [], // 新改, 所选子行业值的 数组或集合
        selectMonths: [], // 新改+, 选择月份的数组, 格式: 123456...
        // selectQuarts: [],         // 新改+, 选择季度的数组, 格式:1234
        selectYears: [], // 新改+, 选择年份的数组,格式 2022年
        // sortNo:'1',              // 由低到高字段, 0-低, 1-高
        sortType: "6", // 排序内容, 0-按信息总量, 1-按知名度, 2-按认知度, 3-按美誉度, 4-按忠诚度, 5-按品牌价值

        selectTimeType: "0", // 新改, 所选时间的类型. 0-按自定义时间查询, 1-按时间范围查询
        scopeTimeStart: "", // 新改, 按时间范围查询_开始时间, 格式: 2022-03
        scopeTimeEnd: "", // 新改, 按时间范围查询_结尾时间, 格式: 2022-04
      },
      tableData: "", // 表格数据
      total: "", // 总条数
      pageNum: "", // 页数（获取）
      pageSize: "", // 每页条数（获取）
      oneIndustryData: [], // 行业一级数据
      oneIndusInput: "", // 行业一级model
      industryOne: false, // 行业一级显示/隐藏
      // industryTwe: false,     // 行业二级显示/隐藏
      // tweIndusInput: '',       // 行业二级model
      acquisitionTime: false, // 采集时间显示/隐藏
      yearData: [], // 年份数据
      yearInput: "", // 年份model
      global: false, // 全国下拉显示/隐藏
      globalData: "", // 全国数据
      globalInput: "中国（含港澳台）", // 全国model
      province: false, // 省下拉显示/隐藏
      provinceInput: "", // 省model
      provinceData: "", // 省数据
      city: false, // 市下拉显示/隐藏
      // cityInput: '',             // 市model
      // cityData: [],              // 市数据

      sortInput: "按拼音首字母排序", // 排序model
      sort: false, // 排序显示/隐藏
      sortData: [
        // 排序数据
        {
          choice: false,
          name: "按拼音首字母排序",
          type: "6",
        },
        {
          choice: false,
          name: "按品牌影响力(信息总量)排序",
          type: "0",
        },
        {
          choice: false,
          name: "按知名度排序",
          type: "1",
        },
        {
          choice: false,
          name: "按认知度排序",
          type: "2",
        },
        {
          choice: false,
          name: "按美誉度排序",
          type: "3",
        },
        {
          choice: false,
          name: "按忠诚度排序",
          type: "4",
        },
      ],

      timeLogin: "", // 登录时间
      loading: false,
      temporary: {
        // 本地暂存
        seach: "", // 查询
        globalData: {
          // 国家
          data: "",
          globalInput: "",
        },
        provinceData: {
          // 省/市
          data: "",
          provinceInput: "",
        },
        yearData: {
          // 时间
          stardTime: "",
          endTime: "",
          type: "0",
          data: "",
          yearInput: "",
        },
        oneIndustryData: {
          // 行业
          data: "",
          oneIndusInput: "",
        },
        orderData: {
          // 排序
          data: "",
          orderInput: "",
        },
        labelData: {
          // 标签
          data: "",
          labelInput: "",
        },
      },

      // 新增-------------
      maskType: false, // 遮罩状态显示/隐藏
      changeGlobalData: "", // 已选国家
      changeProvinceData: [], // 已选省
      changeCityData: [], // 已选市
      changeTimeData: {
        years: [],
        quarters: [],
        months: [],
      }, // 已选采集时间
      changeOneIndustryData: [], // 已选一级行业
      changeTweIndustryData: [], // 已选二级行业
      seachGlobal: {
        // 搜索国家
        countryName: "",
      },
      seachProvince: {
        // 查询省
        // codes: [],          // 所省选地区编码(在选择二级行业接口,传一级行业) 集合,
        fuzzyQuery: "", // 模糊查询字段
      },
      seachTime: {
        // 查询采集时间
        fuzzyQuery: "", // 模糊查询字段
      },
      seachOneIndustry: {
        // 查询行业一级
        fuzzyQuery: "", // 模糊查询字段
      },
      isFixed: false, // 吸地判断依据
      globalCode: "100000", // 国家code
      changeTableData: [], // 表格选择下载的合集
      allTable: false, // 表格全选状态
      scrollWidth: "", // 横向宽度
      labelInput: "", // 标签model
      label: false, // 标签显示/隐藏
      seachLabel: {
        // 查询标签
        fuzzyQuery: "", // 输入的模糊查询字段
      },
      labelData: "", // 标签数据
      changeLabelData: [], // 标签选中数据
      ewmShow: false, // 在线交流二维码显示/隐藏
      loginDialog: false, // 登录弹窗状态
    };
  },
  computed: {},
  created() {
    window.scrollTo(0, 0); // 回滚
    // this.year()
    this.newAccessHomePC(); // PC端 - 首页新访问触发
    this.getAccessHomePC(); // PC端 - 获取今日的访客和浏览量
    this.getOneLevelIndustry(); // 获取一级行业列表
    this.getHomeCountry(); // 国别列表
    this.getHomeProvince(); // 省数据
    this.loginTime(); // 登录时间
    this.getHomeBrandCollectionTimes(); // 获取采集时间
    this.homeBrandLabelPC(); // 获取标签数据
    if (
      sessionStorage.getItem("temporary") != null ||
      sessionStorage.getItem("temporary") != undefined
    ) {
      // 获取本地数据
      this.temporary.seach = JSON.parse(
        sessionStorage.getItem("temporary")
      ).seach;
      this.temporary.globalData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).globalData;
      this.temporary.provinceData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).provinceData;
      this.temporary.yearData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).yearData;
      this.temporary.oneIndustryData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).oneIndustryData;
      this.temporary.orderData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).orderData;
      this.temporary.labelData = JSON.parse(
        sessionStorage.getItem("temporary")
      ).labelData;
      // 查询
      if (JSON.parse(sessionStorage.getItem("temporary")).seach != "") {
        this.seachList.fuzzyQuery = this.temporary.seach;
      }
      // 全国/海外默认值
      if (
        JSON.parse(sessionStorage.getItem("temporary")).globalData.data != ""
      ) {
        this.changeGlobalData = this.temporary.globalData.data;
        this.globalInput = this.temporary.globalData.globalInput;
        this.selectedGlobal();
        this.getHomeCountry();
      }
      // 省份默认值
      if (
        JSON.parse(sessionStorage.getItem("temporary")).provinceData.data != ""
      ) {
        let that = this;
        this.provinceInput = this.temporary.provinceData.provinceInput;
        this.changeProvinceData = this.temporary.provinceData.data;
        this.subProvinceData();
        this.selectedProvince();
        this.getHomeProvince();
      }

      // 采集时间默认值
      if (JSON.parse(sessionStorage.getItem("temporary")).yearData) {
        if (this.temporary.yearData.type == 0) {
          if (this.temporary.yearData.data != "") {
            this.seachList.selectTimeType = this.temporary.yearData.type;
            this.changeTimeData = this.temporary.yearData.data;
            this.yearInput = this.temporary.yearData.yearInput;
            // 处理时间合集
            var years = [];
            var months = [];
            var quarters = [];
            console.log(this.changeTimeData.months);
            this.changeTimeData.years.forEach((item) => {
              years.push(item.name);
            });
            this.changeTimeData.months.forEach((item) => {
              months.push(item.value);
            });
            this.changeTimeData.quarters.forEach((item) => {
              quarters.push(item.value);
            });
            this.seachList.selectYears = years;
            this.seachList.selectMonths = months;
            this.seachList.selectQuarts = quarters;
            this.getHomeBrandCollectionTimes();
            this.selectedTime();
          }
        } else {
          this.seachList.selectTimeType = this.temporary.yearData.type;
          this.seachList.scopeTimeStart = this.temporary.yearData.stardTime;
          this.seachList.scopeTimeEnd = this.temporary.yearData.endTime;
          this.getHomeBrandCollectionTimes();
          this.selectedTime();
        }
      }
      // 行业一级默认值
      if (
        JSON.parse(sessionStorage.getItem("temporary")).oneIndustryData.data !=
        ""
      ) {
        let that = this;
        this.changeOneIndustryData = this.temporary.oneIndustryData.data;
        this.oneIndusInput = this.temporary.oneIndustryData.oneIndusInput;
        // 已选codes处理
        var codes = [];
        this.changeOneIndustryData.forEach((item) => {
          codes.push(item.typeValue);
        });
        // 获取数据
        this.seachList.subIndustryValues = codes;
        this.getOneLevelIndustry();
        this.selectedIndustry();
      }
      // 排序默认
      if (JSON.parse(sessionStorage.getItem("temporary")).orderData != "") {
        this.seachList.sortType = this.temporary.orderData.data;
        this.sortInput = this.temporary.orderData.orderInput;
      }
      // 标签默认
      if (JSON.parse(sessionStorage.getItem("temporary")).labelData != "") {
        this.changeLabelData = this.temporary.labelData.data;
        this.labelInput = this.temporary.labelData.labelInput;
        this.homeBrandLabelPC();
        this.selectedLable();
      }
    }
    this.getBrandInfoRankingPC(); // PC端 - 首页企业品牌排行
  },
  mounted() {
    window.addEventListener("click", this.otherClose, true);
    window.addEventListener("scroll", this.handleScroll, true); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    window.addEventListener("scroll", this.handleWidthScroll, true); // 监听滚动事件，然后用handleWidthScroll这个方法进行相应的处理
    this.handleWidthScroll();
  },
  destroyed() {
    /* 组件销毁的时候要移除侦听器 */
    window.removeEventListener("click", this.otherClose, true);
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("scroll", this.handleWidthScroll, true);
  },
  methods: {
    // ------------------ 复制 -------------------------------
    getCopy() {
      let url = '卓闻数据 · 全球品牌数据库。公司官网：www.zhuowendata.com 登录日期：' + this.timeLogin
      let txa = document.createElement("textarea");   
      txa.value = url;
      document.body.appendChild(txa)
      txa.select(); 
      document.execCommand("Copy");  
      document.body.removeChild(txa);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    // ------------------ end -------------------------------
    // ------------------在线交流-----------------------------
    // communication() {
    //     this.maskType = true
    //     this.ewmShow = true
    //     console.log(this.maskType);
    // },
    // --------------------end--------------------------------
    // ------------------选择标签-----------------------------
    homeBrandLabelPC() {
      var that = this;
      // var data = JSON.stringify(that.seachTime)
      $.ajax({
        type: "GET",
        dataType: "json", //通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        data: that.seachLabel, //上传的参数
        async: false,
        url: this.url + "/apis/survey/companyBrand/homeBrandLabelPC", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          console.log("标签", data.data);
          // 处理数据
          data.data.forEach((item) => {
            item.choice = false;
          });
          that.labelData = data.data;

          // 处理已选
          that.selectedLable()
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    choiceLabel(item) {
      item.choice = !item.choice;
      if (item.choice) {
        this.changeLabelData.push(item);
      } else {
        this.changeLabelData.forEach((it, ix) => {
          if (it.id == item.id) {
            this.changeLabelData.splice(ix, 1);
          }
        });
        this.labelData.forEach((i) => {
          if (i.id == item.id) {
            i.choice = false;
          }
        });
      }
    },
    // 查询
    queryLabel() {
      this.homeBrandLabelPC();
    },
    // 重置
    resetLabelData() {
      this.seachLabel.fuzzyQuery = "";
      this.homeBrandLabelPC();
    },
    // 确认
    subLabelData() {
      if (this.changeLabelData.length > 0) {
        this.labelInput = "标签已选（" + this.changeLabelData.length + "）";
        this.seachList.brandLabels = []
      } else {
        this.labelInput = "全部";
        this.seachList.brandLabels = []
      }
      this.maskType = false;
      this.label = false;
      // 处理已选标签合集
      this.changeLabelData.forEach((item) => {
        this.seachList.brandLabels.push(item.id);
      });
    },
    // --------------------end--------------------------------
    // ------------------批量下载-----------------------------
    // 批量下载报告(word,pdf)
    updownWord() {
      var ids = [];
      // 处理id合集
      if (this.changeTableData.length > 0) {
        this.changeTableData.forEach((item) => {
          ids.push(item.reportId);
        });
      }
      // 限制判断
      if (ids.length == 0) {
        this.$message.error("请勾选品牌");
        return;
      }
      if (ids.length >= 15) {
        this.$message.error("最多勾选15个品牌");
        return;
      }
      // 下载接口
      // var that = this
      let str = `ids=${ids}`;
      // let str = `ids=2`;
      console.log(str);
      window.open(
        this.url + `/apis/survey/companyBrand/downloadBrandReportFile?${str}`
      );
    },
    // 批量下载数据（exce）
    updownExce() {
      var data = {
        brandLabels: this.seachList.brandLabels,
        ids: [],
        codes: this.seachList.codes,
        fuzzyQuery: this.seachList.fuzzyQuery,
        scopeTimeEnd: this.seachList.scopeTimeEnd,
        scopeTimeStart: this.seachList.scopeTimeStart,
        selectMonths: this.seachList.selectMonths,
        selectTimeType: this.seachList.selectTimeType,
        selectYears: this.seachList.selectYears,
        sortType: this.seachList.sortType,
        subIndustryValues: this.seachList.subIndustryValues,
      };
      // 处理id合集
      if (this.changeTableData.length > 0) {
        this.changeTableData.forEach((item) => {
          data.ids.push(item.reportId);
        });
      }
      // 限制判断
      if (data.ids.length == 0) {
        this.$message.error("请勾选品牌");
        return;
      }
      if (data.ids.length > 15) {
        this.$message.error("最多勾选15个品牌");
        return;
      }
      // 下载接口
      if(getToken() != undefined) {
        // var that = this
        let str = `ids=${data.ids}&brandLabels=${data.brandLabels}&codes=${data.codes}&fuzzyQuery=${data.fuzzyQuery}&scopeTimeEnd=${data.scopeTimeEnd}&scopeTimeStart=${data.scopeTimeStart}&selectMonths=${data.selectMonths}&selectTimeType=${data.selectTimeType}&selectYears=${data.selectYears}&sortType=${data.sortType}&subIndustryValues=${data.subIndustryValues}`;
        console.log(str);
        window.open(
          this.url + `/apis/survey/companyBrand/exportBrandDataExcelsPC?${str}`
        );
      } else {
        this.loginDialog = true
      }
    },
    // 表格全选
    allChangeTable() {
      console.log(this.changeTableData.length + this.seachList.pageSize);
      // 限制勾选
      if (this.changeTableData.length + this.seachList.pageSize <= 15) {
        this.allTable = !this.allTable;
        if (this.allTable) {
          this.tableData.forEach((item) => {
            if(!item.choice) {
              this.choiceTable(item)
            }
          });
        } else {
          this.tableData.forEach((item) => {
            this.changeTableData.forEach((it, ix) => {
              if (item.reportId == it.reportId) {
                item.choice = false;
                this.changeTableData.splice(ix, 1);
              }
            });
          });
        }
      } else {
        if(this.allTable) {
          this.allTable = false
          this.tableData.forEach((item) => {
            this.changeTableData.forEach((it, ix) => {
              if (item.reportId == it.reportId) {
                item.choice = false;
                this.changeTableData.splice(ix, 1);
              }
            });
          });
        } else {
          this.$message.error('最多勾选15个品牌');
          return
        }
      }
      // console.log("列表选择", this.changeTableData);
    },
    // 表格选择
    choiceTable(item) {
      // 限制勾选
      if (this.changeTableData.length < 15) {
        item.choice = !item.choice;
        if (item.choice) {
          this.changeTableData.push(item);
        } else {
          this.changeTableData.forEach((it, ix) => {
            if (item.reportId == it.reportId) {
              this.changeTableData.splice(ix, 1);
            }
          });
        }
      } else {
        if(item.choice) {
          item.choice = false;
          this.changeTableData.forEach((it, ix) => {
            if (item.reportId == it.reportId) {
              this.changeTableData.splice(ix, 1);
            }
          });
        } else {
          this.$message.error("最多勾选15个品牌");
          return
        }
      }
      // console.log("列表选择", this.changeTableData);
    },
    // --------------------end--------------------------------
    // ------------------计算滚动-----------------------------
    // 计算横向滚动
    handleWidthScroll() {
      var size = window.getComputedStyle(
        document.getElementById("centBox"),
        null
      );
      var scrollLeft =
        document.documentElement.scrollLeft || document.body.scrollLeft;
      this.scrollWidth =
        document.documentElement.clientWidth -
        document.getElementById("tab").offsetLeft -
        size.marginRight.slice(0, -2) -
        size.paddingRight.slice(0, -2) +
        scrollLeft;
    },
    // 计算纵向滚动
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      var tabHeight = document.getElementById("tab").offsetTop; // 高度
      if (scrollTop >= tabHeight) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    // ---------------------end-------------------------------
    // -----------------筛选查询/重置-------------------------
    // 重置
    reset() {
      // 请求数据清除
      this.seachList.fuzzyQuery = "";
      this.seachList.codes = ["100000"];
      this.seachList.subIndustryValues = [];
      this.seachList.selectMonths = [];
      this.seachList.selectQuarts = [];
      this.seachList.selectYears = [];
      this.seachList.sortType = "6";
      this.seachList.selectTimeType = "0";
      this.seachList.scopeTimeStart = "";
      this.seachList.scopeTimeEnd = "";
      this.seachList.brandLabels = [];

      // 清除输入框
      this.oneIndusInput = "";
      this.yearInput = "";
      this.globalInput = "中国（含港澳台）";
      this.provinceInput = "";
      this.sortInput = "按拼音首字母排序";
      this.labelInput = "";

      // 行业清除
      this.allClearIndustry();
      // 省清除
      this.changeProvinceData = [];
      this.getHomeProvince();
      // 标签清除
      this.changeLabelData = [];
      this.homeBrandLabelPC();
      // 采集时间清除
      this.allClearTime();
      // 清除本地缓存
      sessionStorage.clear();

      this.getBrandInfoRankingPC();
    },
    // 查询
    query() {
      // 储存--搜索
      this.temporary.seach = this.seachList.fuzzyQuery
      // 储存--国家选择
      this.temporary.globalData.data = this.changeGlobalData;
      this.temporary.globalData.globalInput = this.globalInput;
      // 储存--省/市选择
      this.temporary.provinceData.data = this.changeProvinceData;
      this.temporary.provinceData.provinceInput = this.provinceInput;
      // 储存--时间
      if (this.seachList.selectTimeType == 0) {
        this.temporary.yearData.type = this.seachList.selectTimeType;
        this.temporary.yearData.data = this.changeTimeData;
        this.temporary.yearData.yearInput = this.yearInput;
        this.temporary.yearData.stardTime = "";
        this.temporary.yearData.endTime = "";
      } else {
        this.temporary.yearData.type = this.seachList.selectTimeType;
        this.temporary.yearData.stardTime = this.seachList.scopeTimeStart;
        this.temporary.yearData.endTime = this.seachList.scopeTimeEnd;
        this.temporary.yearData.data = [];
        this.temporary.yearData.yearInput = "";
      }
      // 储存--行业
      this.temporary.oneIndustryData.data = this.changeOneIndustryData;
      this.temporary.oneIndustryData.oneIndusInput = this.oneIndusInput;
      // 储存--排序
      this.temporary.orderData.data = this.seachList.sortType;
      this.temporary.orderData.orderInput = this.sortInput;
      // 储存--标签
      this.temporary.labelData.data = this.changeLabelData;
      this.temporary.labelData.labelInput = this.labelInput;

      sessionStorage.setItem("temporary", JSON.stringify(this.temporary));
      this.seachList.pageNum = 1;
      this.getBrandInfoRankingPC();
    },
    // ----------------------end------------------------------
    // ------------------选择信息反选-------------------------
    // 国家选择数据code
    selectedGlobal() {
      if (this.changeGlobalData != "") {
        this.globalData.forEach((item) => {
          if (item.code == this.changeGlobalData.code) {
            // 查询数据赋值
            this.seachList.codes.push(item.code);
            // 国家code赋值
            this.globalCode = item.code;
          }
        });
      }
    },
    // 省/市反选
    selectedProvince() {
      this.changeProvinceData.forEach((item) => {
        var numW = 0;
        this.provinceData.child.forEach((em) => {
          var numZ = 0;
          if (item.code == em.code) {
            em.allChoice = true;
          }
          if (em.subInfos) {
            em.subInfos.forEach((i) => {
              if (i.code == item.code) {
                i.choice = true;
              }
              if (i.choice == false) {
                numZ++;
              }
            });
            if (numZ == 0) {
              em.allChoice = true;
            }
          }
          if (em.allChoice == false) {
            numW++;
          }
        });
        if (numW == 0) {
          this.provinceData.allChoice = true;
        }
      });
    },
    // 时间反选
    selectedTime() {
      console.log(this.changeTimeData);
      this.yearData.forEach((item) => {
        var numY = 0;
        var numU = 0;
        var numI = 0;
        item.child.forEach((it) => {
          this.changeTimeData.months.forEach((q) => {
            if (it.name == q.name) {
              it.choice = q.choice;
            }
          });
          if (it.choice == false) {
            numY++;
          }
          this.changeTimeData.quarters.forEach((z) => {
            if (it.name == z.name) {
              it.choice = z.choice;
            }
          });
          if (it.choice == false) {
            numU++;
          }
          this.changeTimeData.years.forEach((r) => {
            if (it.name == r.name) {
              it.choice = r.choice;
            }
          });
          if (it.choice == false) {
            numI++;
          }
        });
        if (numY == 0 || numU == 0 || numI == 0) {
          item.allChoice = true;
        }
      });
    },
    // 行业反选
    selectedIndustry() {
      this.changeOneIndustryData.forEach((item) => {
        this.oneIndustryData.forEach((it) => {
          if (item.preTypeValue == it.id) {
            var numH = 0;
            it.subIndustryList.forEach((em) => {
              if (item.id == em.id) {
                em.choice = item.choice;
              }
              if (em.choice == false) {
                numH++;
              }
            });
            if (numH == 0) {
              it.allChoice = true;
            }
          }
        });
      });
    },
    // 标签反选
    selectedLable() {
      this.changeLabelData.forEach((item) => {
        this.labelData.forEach((it) => {
          if (item.id == it.id) {
            it.choice = true;
          }
        });
      });
    },
    // ----------------------end------------------------------
    // --------------------左侧排序---------------------------
    // 排序选择
    choiceSort(item) {
      this.sortInput = item.name;
      this.seachList.sortType = item.type;
      this.sort = false;
      this.maskType = false;
    },
    // ----------------------end------------------------------
    // ------------------左侧行业一级-------------------------
    // 全部清除
    allClearIndustry() {
      this.oneIndustryData.forEach((item) => {
        item.allChoice = false;
        item.subIndustryList.forEach((i) => {
          if (i.choice == true) {
            this.choiceOneIndustry(i);
          }
        });
      });
    },
    // 全选
    allCheckIndustry() {
      console.log(this.oneIndustryData);
      this.oneIndustryData.forEach((item) => {
        var numR = 0;
        item.subIndustryList.forEach((i) => {
          if (i.choice == false) {
            this.choiceOneIndustry(i);
            if (i.choice == false) {
              numR++;
            }
          }
        });
        if (numR == 0) {
          item.allChoice = true;
        }
      });
    },
    // 左侧折叠/展示
    openIndustryClose(item) {
      item.choice = !item.choice;
    },
    // 确定
    subOneIndustryData() {
      console.log(this.changeOneIndustryData);
      if (this.changeOneIndustryData.length > 0) {
        this.oneIndusInput =
          "行业（已选择" + this.changeOneIndustryData.length + ")";
      } else {
        this.oneIndusInput = "行业（全部）";
      }
      this.industryOne = false;
      this.maskType = false;
      // 已选codes处理
      var codes = [];
      this.changeOneIndustryData.forEach((item) => {
        codes.push(item.typeValue);
      });
      // 获取数据
      this.seachList.subIndustryValues = codes;
    },
    // 重置
    resetOneIndustryData() {
      this.seachOneIndustry.fuzzyQuery = "";
      this.getOneLevelIndustry();
    },
    // 查询
    queryOneIndustry() {
      this.oneIndustryData = [];
      this.getOneLevelIndustry();
    },
    // 选择行业
    choiceOneIndustry(item) {
      item.choice = !item.choice;
      if (item.choice) {
        this.changeOneIndustryData.push(item);
      } else {
        this.oneIndustryData.forEach((i) => {
          i.subIndustryList.forEach((z) => {
            if (z.id == item.id) {
              z.choice = false;
              this.changeOneIndustryData.forEach((it, index) => {
                if (item.id == it.id) {
                  this.changeOneIndustryData.splice(index, 1);
                }
              });
            }
          });
        });
      }
    },
    // 选择全选行业
    allChoiceOneIndustry(item) {
      console.log(item);
      item.allChoice = !item.allChoice;
      if (item.allChoice) {
        item.subIndustryList.forEach((it) => {
          if (it.choice == false) {
            this.choiceOneIndustry(it);
          }
        });
      } else {
        item.subIndustryList.forEach((it) => {
          if (it.choice == true) {
            this.choiceOneIndustry(it);
          }
        });
      }
    },
    // ----------------------end------------------------------
    // ---------------------左侧省----------------------------
    // 确认
    subProvinceData() {
      console.log("省/市", this.changeProvinceData);
      if (this.changeProvinceData.length > 0) {
        this.provinceInput =
          "省/市（已选择" + this.changeProvinceData.length + ")";
      } else {
        this.provinceInput = "省/市（全部）";
      }
      this.province = false;
      this.maskType = false;
      // 处理已选合集code
      this.seachProvince.codes = [];
      this.changeProvinceData.forEach((o) => {
        this.seachProvince.codes.push(o.code);
      });
      // 获取数据
      this.seachList.codes = this.seachProvince.codes;
      if (this.seachProvince.codes.length == 0) {
        this.seachList.codes = this.seachProvince.codes;
      }
    },
    // 重置
    resetProvinceData() {
      this.seachProvince.fuzzyQuery = "";
      this.getHomeProvince();
    },
    // 查询
    queryProvince() {
      this.getHomeProvince();
    },
    // 左侧选择折叠
    opPrimary(item) {
      item.choice = !item.choice;
    },
    opMinor(item) {
      item.choice = !item.choice;
    },
    // 左侧选择折叠
    openClose(item) {
      item.choice = !item.choice;
    },
    // 全选
    allChoiceProvince(item) {
      console.log(item);
      item.allChoice = !item.allChoice;
      if (item.allChoice) {
        item.child.forEach((it) => {
          it.allChoice = true;
          if (
            it.code == "110000" ||
            it.code == "120000" ||
            it.code == "310000" ||
            it.code == "500000" ||
            it.code == "710000" ||
            it.code == "810000" ||
            it.code == "820000"
          ) {
            this.changeProvinceData.push(it);
          } else {
            it.allChoice = true;
            it.subInfos.forEach((em) => {
              em.choice = true;
              this.changeProvinceData.push(em);
            });
          }
        });
      } else {
        this.changeProvinceData = [];
        this.getHomeProvince();
      }
    },
    // 省/市 单一全选
    allChoiceProvinceTwe(val) {
      val.allChoice = !val.allChoice;
      console.log(val);
      // 处理没有子集的省/市
      // val.code == '110000' || val.code == '120000' || val.code == '310000' || val.code == '500000'
      //     || val.code == '710000' || val.code == '810000' || val.code == '820000'
      // if(val.code == '110000' || val.code == '120000' || val.code == '310000' || val.code == '500000'
      //     || val.code == '710000' || val.code == '810000' || val.code == '820000') {
      if (val.allChoice) {
        this.changeProvinceData.push(val);
      } else {
        this.changeProvinceData.forEach((i, index) => {
          if (i.code == val.code) {
            this.changeProvinceData.splice(index, 1);
          }
        });
      }
      // } else {
      //     if(val.allChoice) {
      //         val.subInfos.forEach(i => {
      //             if(i.choice == false) {
      //                 this.choiceProvince(i)
      //             }
      //         })
      //     } else {
      //         val.subInfos.forEach(i => {
      //             if(i.choice == true) {
      //                 this.choiceProvince(i)
      //             }
      //         })
      //     }
      // }
    },
    // 选择省
    choiceProvince(item) {
      console.log(item);
      if (item.level == 1) {
        item.allChoice = !item.allChoice;
        if (item.allChoice) {
          this.changeProvinceData.push(item);
        } else {
          this.changeProvinceData.forEach((i, index) => {
            if (i.code == item.code) {
              this.changeProvinceData.splice(index, 1);
            }
          });
          this.provinceData.child.forEach((z) => {
            if (z.code == item.code) {
              z.allChoice = false;
            }
          });
        }
      } else {
        item.choice = !item.choice;
        if (item.choice) {
          this.changeProvinceData.push(item);
        } else {
          this.changeProvinceData.forEach((i, index) => {
            if (i.id == item.id) {
              this.changeProvinceData.splice(index, 1);
            }
          });
          this.provinceData.child.forEach((z) => {
            var numP = 0;
            if (z.subInfos) {
              z.subInfos.forEach((o) => {
                if (o.code == item.code) {
                  o.choice = false;
                }
                if (numP == true) {
                  numP++;
                }
              });
              // if(numP == 0) {
              //     z.allChoice = false
              // }
            }
          });
        }
      }
    },
    // ----------------------end------------------------------
    // ------------------左侧采集时间-------------------------
    // PC端 - 03_22首页获取时间下拉框,可模糊搜索
    getHomeBrandCollectionTimes() {
      var that = this;
      // var data = JSON.stringify(that.seachTime)
      $.ajax({
        type: "GET",
        dataType: "json", //通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        data: that.seachTime, //上传的参数
        async: false,
        url: this.url + "/apis/survey/companyBrand/homeBrandCollectionTimesPC", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          console.log("采集时间", data.data);
          that.yearData = [];
          // 处理年份数据
          var years = {
            child: [],
          };
          years.name = "年份";
          years.choice = true;
          years.allChoice = false;
          if (data.data.years != null) {
            data.data.years.forEach((item) => {
              years.child.push({
                name: item,
                choice: false,
                years: "年份",
              });
            });
            that.yearData.push(years);
          }
          // 处理季度
          var quarters = {
            child: [],
          };
          quarters.name = "季度";
          quarters.choice = true;
          quarters.allChoice = false;
          if (data.data.quarters != null) {
            data.data.quarters.forEach((item) => {
              quarters.child.push({
                value: item.value,
                name: item.name,
                choice: false,
                quarters: "季度",
              });
            });
            that.yearData.push(quarters);
          }
          // 处理月份
          var months = {
            child: [],
          };
          months.name = "月份";
          months.choice = true;
          months.allChoice = false;
          if (data.data.months != null) {
            data.data.months.forEach((item) => {
              months.child.push({
                value: item.value,
                name: item.name,
                choice: false,
                months: "月份",
              });
            });
            that.yearData.push(months);
          }
          console.log("年份", that.yearData);

          // 年份反选
          that.selectedTime();
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // 全体清除
    allClearTime() {
      this.yearData.forEach((item) => {
        item.allChoice = false;
        item.child.forEach((i) => {
          if (i.choice == true) {
            this.choiceTime(i);
          }
        });
      });
    },
    // 整体全选
    allCheckTime() {
      this.yearData.forEach((item) => {
        var numR = 0;
        item.child.forEach((i) => {
          if (i.choice == false) {
            this.choiceTime(i);
            if (i.choice == false) {
              numR++;
            }
          }
        });
        if (numR == 0) {
          item.allChoice = true;
        }
      });
    },
    // 左侧折叠/展示
    openTimeClose(item) {
      item.choice = !item.choice;
      console.log(item.choice);
      console.log(this.yearData);
    },
    // 年份/月份/季度单一全选
    allChoiceTime(item) {
      console.log(item);
      item.allChoice = !item.allChoice;
      if (item.allChoice) {
        item.child.forEach((i) => {
          if (i.choice == false) {
            this.choiceTime(i);
          }
        });
      } else {
        item.child.forEach((i) => {
          if (i.choice == true) {
            this.choiceTime(i);
          }
        });
      }
    },
    // 选择时间
    choiceTime(item) {
      item.choice = !item.choice;
      if (item.choice) {
        if (item.years == "年份") {
          this.changeTimeData.years.push(item);
        }
        if (item.quarters == "季度") {
          this.changeTimeData.quarters.push(item);
        }
        if (item.months == "月份") {
          this.changeTimeData.months.push(item);
        }
      } else {
        this.yearData.forEach((z) => {
          z.child.forEach((o) => {
            if (o.name == item.name) {
              o.choice = false;
              if (item.years == "年份") {
                this.changeTimeData.years.forEach((i, index) => {
                  if (i.name == item.name) {
                    this.changeTimeData.years.splice(index, 1);
                  }
                });
              }
              if (item.quarters == "季度") {
                this.changeTimeData.quarters.forEach((i, index) => {
                  if (i.name == item.name) {
                    this.changeTimeData.quarters.splice(index, 1);
                  }
                });
              }
              if (item.months == "月份") {
                this.changeTimeData.months.forEach((i, index) => {
                  if (i.name == item.name) {
                    this.changeTimeData.months.splice(index, 1);
                  }
                });
              }
            }
          });
        });
      }
    },
    // 确认
    subTimeData() {
      console.log(this.changeTimeData);
      if (
        this.changeTimeData.years.length > 0 ||
        this.changeTimeData.months.length > 0 ||
        this.changeTimeData.quarters.length > 0
      ) {
        var num =
          this.changeTimeData.years.length +
          this.changeTimeData.months.length +
          this.changeTimeData.quarters.length;
        this.yearInput = "采集时间（已选择" + num + ")";
      } else {
        this.yearInput = "全部";
      }
      this.acquisitionTime = false;
      this.maskType = false;
      // 处理时间合集
      var years = [];
      var months = [];
      var quarters = [];
      this.changeTimeData.years.forEach((item) => {
        years.push(item.name);
      });
      this.changeTimeData.months.forEach((item) => {
        months.push(item.value);
      });
      this.changeTimeData.quarters.forEach((item) => {
        quarters.push(item.value);
      });
      this.seachList.selectYears = years;
      this.seachList.selectMonths = months;
      this.seachList.selectQuarts = quarters;
      console.log("请求数据", this.seachList);
    },
    // 重置
    resetTimeData() {
      this.seachTime.fuzzyQuery = "";
      this.getHomeBrandCollectionTimes();
    },
    // 查询采集时间
    queryTime() {
      this.getHomeBrandCollectionTimes();
    },
    // ----------------------end------------------------------
    // --------------------左侧国家---------------------------
    // 查询国家
    queryGlobal() {
      this.getHomeCountry();
    },
    // 选择国家
    choiceGlobal(item) {
      // 选择
      this.changeGlobalData = item;
      console.log(this.changeGlobalData);
      item.choice = !item.choice;
      // 国家code赋值
      this.globalCode = item.code;
      // 清空codes
      this.seachList.codes = [];
      // model值
      this.globalInput = item.name;
      // 查询数据赋值
      this.seachList.codes.push(item.code);
      // 关闭弹窗
      this.global = false;
      this.maskType = false;
    },
    // 重置国家
    resetGlobalData() {
      this.seachGlobal.countryName = "";
      this.getHomeCountry();
    },
    // ------------------------end----------------------------
    // 点击关闭弹窗
    otherClose(e) {
      if (!this.$refs.container.contains(e.target)) this.global = false;
      if (!this.$refs.container.contains(e.target)) this.province = false;
      if (!this.$refs.container.contains(e.target))
        this.acquisitionTime = false;
      if (!this.$refs.container.contains(e.target)) this.industryOne = false;
      if (!this.$refs.container.contains(e.target)) this.maskType = false;
      if (!this.$refs.container.contains(e.target)) this.sort = false;
      if (!this.$refs.container.contains(e.target)) this.label = false;
      if (!this.$refs.container.contains(e.target)) this.ewmShow = false;
    },
    // 获取当前登录时间
    loginTime() {
      //获取当前时间
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.timeLogin = year + "年" + month + "月" + day + "日";
    },
    // 跳转关于我们
    goAbout() {
      window.location.href = `./about.html`;
    },
    // 跳转首页
    goIndex() {
      window.location.href = `./index.html`;
    },
    // 跳转详情/ 判断是否登录
    goDetail(item) {
      if(getToken() != undefined) {
        if(item.dataReportId) {
          this.$router.push({ path: "/queryDetails", query: { dataReportId: item.dataReportId} });
        } else {
          this.$router.push({ path: "/queryDetails", query: { id: item.id } });
        }
      } else {
        this.loginDialog = true
      }
      // window.location.href = `./queryDetails.html?id=${item.id}&companyType_dictValue=${item.industryName}&companyName=${item.companyName}`;
    },

    // ------------------废弃----------------------
    // 忠诚度修改
    changeLoyalty() {
      this.loyalty++;
      // 其他清空
      this.seachList.informationSort = "";
      this.seachList.awarenessSort = "";
      this.seachList.reputationSort = "";
      this.seachList.popularitySort = "";
      if (this.loyalty == 0) {
        // 查询值
        this.seachList.loyaltySort = 0;
        this.getBrandInfoRankingPC();
      }
      if (this.loyalty == 1) {
        // 查询值
        this.seachList.loyaltySort = 1;
        this.getBrandInfoRankingPC();
      }
      if (this.loyalty == 2) {
        // 查询值
        this.loyalty = -1;
        this.seachList.loyaltySort = "";
        this.getBrandInfoRankingPC();
      }
    },
    // 美誉度修改
    changeReputation() {
      this.reputation++;
      // 其他清空
      this.seachList.informationSort = "";
      this.seachList.awarenessSort = "";
      this.seachList.loyaltySort = "";
      this.seachList.popularitySort = "";
      if (this.reputation == 0) {
        // 查询值
        this.seachList.reputationSort = 0;
        this.getBrandInfoRankingPC();
      }
      if (this.reputation == 1) {
        // 查询值
        this.seachList.reputationSort = 1;
        this.getBrandInfoRankingPC();
      }
      if (this.reputation == 2) {
        // 查询值
        this.reputation = -1;
        this.seachList.reputationSort = "";
        this.getBrandInfoRankingPC();
      }
    },
    // 认知度修改
    changeAwareness() {
      this.awareness++;
      // 其他清空
      this.seachList.informationSort = "";
      this.seachList.reputationSort = "";
      this.seachList.loyaltySort = "";
      this.seachList.popularitySort = "";
      if (this.awareness == 0) {
        // 查询值
        this.seachList.awarenessSort = 0;
        this.getBrandInfoRankingPC();
      }
      if (this.awareness == 1) {
        // 查询值
        this.seachList.awarenessSort = 1;
        this.getBrandInfoRankingPC();
      }
      if (this.awareness == 2) {
        // 查询值
        this.awareness = -1;
        this.seachList.awarenessSort = "";
        this.getBrandInfoRankingPC();
      }
    },
    // 信息总量修改
    changeInformation() {
      this.information++;
      // 其他清空
      this.seachList.awarenessSort = "";
      this.seachList.reputationSort = "";
      this.seachList.loyaltySort = "";
      this.seachList.popularitySort = "";
      if (this.information == 0) {
        // 查询值
        this.seachList.informationSort = 0;
        this.getBrandInfoRankingPC();
      }
      if (this.information == 1) {
        // 查询值
        this.seachList.informationSort = 1;
        this.getBrandInfoRankingPC();
      }
      if (this.information == 2) {
        // 查询值
        this.information = -1;
        this.seachList.informationSort = "";
        this.getBrandInfoRankingPC();
      }
    },
    // 知名度状态修改
    changePopularity() {
      this.popularity++;
      // 其他清空
      this.seachList.awarenessSort = "";
      this.seachList.reputationSort = "";
      this.seachList.loyaltySort = "";
      this.seachList.informationSort = "";
      if (this.popularity == 0) {
        // 查询值
        this.seachList.popularitySort = 0;
        this.getBrandInfoRankingPC();
      }
      if (this.popularity == 1) {
        // 查询值
        this.seachList.popularitySort = 1;
        this.getBrandInfoRankingPC();
      }
      if (this.popularity == 2) {
        // 查询值
        this.popularity = -1;
        this.seachList.popularitySort = "";
        this.getBrandInfoRankingPC();
      }
    },
    // -------------------end----------------------

    // PC端 - 首页新访问触发
    newAccessHomePC() {
      var that = this;
      $.ajax({
        type: "POST",
        // dataType: "json",//通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        // data: data,                                 //上传的参数
        async: false,
        url: this.url + "/apis/survey/visitCount/newAccessHomePC", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          // console.log("触发", data)
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // PC端 - 获取今日的访客和浏览量
    getAccessHomePC() {
      var that = this;
      $.ajax({
        type: "POST",
        // dataType: "json",//通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        // data: data,                                 //上传的参数
        async: false,
        url: this.url + "/apis/survey/visitCount/getAccessHomePC", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          console.log("今日的访客和浏览量", data.data);
          that.visitVrowse = data.data;
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // PC端 - 首页企业品牌排行
    getBrandInfoRankingPC() {
      this.loading = true;
      var that = this;
      var data = JSON.stringify(that.seachList);
      $.ajax({
        type: "POST",
        // dataType: "json",//通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        data: data, //上传的参数
        async: false,
        url: this.url + "/apis/survey/companyBrand/brandInfoRankingPCProvince", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          if (data.code == 200) {
            data.data.list.forEach((item) => {
              item.choice = false;
              if(item.allLabelName != null) {
                item.allLabelName = item.allLabelName.split(",")
              }
            });
            console.log(99999999999,data.data.list);
            // console.log("首页企业品牌排行", data.data.list[0].allLabelName[0]);
            that.allTable = false;
            that.tableData = data.data.list;
            that.total = data.data.total;
            that.pageNum = data.data.pageNum;
            that.pageSize = data.data.pageSize;
            // that.$nextTick(function () {
              that.loading = false;
            // });
            // 处理被选中状态
            if (that.changeTableData.length > 0) {
              that.changeTableData.forEach((item) => {
                var numP = 0;
                that.tableData.forEach((it) => {
                  if (item.id == it.id) {
                    it.choice = true;
                  }
                  if (it.choice == false) {
                    numP++;
                  }
                });
                if (numP == 0) {
                  that.allTable = true;
                }
              });
            }
          }
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.seachList.pageNum = val;
      this.getBrandInfoRankingPC();
    },
    // 获取一级行业列表
    getOneLevelIndustry() {
      var that = this;
      $.ajax({
        type: "GET",
        dataType: "json", //通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        // data: data,                                 //上传的参数
        async: false,
        url:
          this.url +
          "/apis/survey/companyBrand/getPCIndustryList?fuzzyQuery=" +
          that.seachOneIndustry.fuzzyQuery, //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          console.log("获取一级行业列表", data.data);
          // that.oneIndustryData = []
          data.data.forEach((item) => {
            item.allChoice = false;
            item.choice = true;
            item.subIndustryList.forEach((it) => {
              it.choice = false;
            });
          });
          that.oneIndustryData = data.data;
          console.log("999", that.oneIndustryData);

          // 行业反选
          that.selectedIndustry();
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },

    // 国别列表
    getHomeCountry() {
      var that = this;
      $.ajax({
        type: "GET",
        dataType: "json", //通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        data: this.seachGlobal, //上传的参数
        async: false,
        url: this.url + "/apis/survey/companyBrand/getHomeCountry", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          console.log("国别列表", data.data);
          data.data.forEach((item) => {
            item.choice = false;
          });
          that.globalData = data.data;
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // 省列表
    getHomeProvince() {
      var that = this;
      console.log(that.seachProvince);
      $.ajax({
        type: "GET",
        dataType: "json", //通过GET方式上传请求
        contentType: "application/json", //上传内容格式为json结构
        data: that.seachProvince, //上传的参数
        async: false,
        url: this.url + "/apis/survey/companyBrand/homeAllProvinceCityPC", //请求的url。与后端@Request Mapping注解中的值一致。
        success: function (data) {
          //请求成功的回调函数
          var newData = {};
          data.data.forEach((item) => {
            item.choice = true;
            item.allChoice = false;
            if (item.subInfos != null) {
              item.subInfos.forEach((i) => {
                i.choice = false;
              });
            }
          });
          newData.name = "所有省市";
          newData.choice = true;
          newData.allChoice = false;
          newData.child = data.data;
          console.log("新数据", newData);
          that.provinceData = newData;

          // 处理反选
          that.selectedProvince();
        },
        error: function (e) {
          //请求失败的回调函数
          console.log(e);
        },
      });
    },
    // 登录状态回调
    loginClose(data) {
      this.loginDialog = data
    }
  },
};
</script>

<style scoped lang='less'>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .query {
    min-width: 1440px;
    .query_nav {
      min-width: 1440px;
      ._navBox {
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
      }
    }
    .query_seach {
      min-width: 1440px;
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;
      ._searchKong {
        flex: 0.8;
      }
      ._seachLeft {
        flex: 1.7;
      }
      ._seachRight {
        flex: 0.7;
      }
    }
    .query_tabs {
      min-width: 1440px;
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;

      ._tabsLeft {
        width: 268px;
      }
      ._tabsRight {
        width: 1152px;
        margin-left: 10px;
        ._tabsTop {
          ul {
            width: 1152px;
            li {
              padding: 0 5px 0 5px;
              box-sizing: border-box;
            }
            :nth-child(1) {
              flex: 1;
            }
            :nth-child(2) {
              flex: 1;
            }
            :nth-child(3) {
              flex: 1;
            }
            :nth-child(5) {
              flex: 1.6;
            }
            :nth-child(4) {
              flex: 1.3;
            }
            :nth-child(6) {
              flex: 1.1;
            }
            :nth-child(7) {
              flex: 1.1;
            }
            :nth-child(8) {
              flex: 1.1;
            }
            :nth-child(9) {
              flex: 1.1;
            }
            :nth-child(10) {
              flex: 0.9;
            }
          }
        }
        ._tabsbottom {
          width: 1152px;
          ul {
            width: 1152px;
            li {
              padding: 14px 5px 12px 5px;
              box-sizing: border-box;
            }
            :nth-child(1) {
              flex: 1;
            }
            :nth-child(2) {
              flex: 1;
            }
            :nth-child(3) {
              flex: 1;
            }
            :nth-child(5) {
              flex: 1.6;
            }
            :nth-child(4) {
              flex: 1.3;
            }
            :nth-child(6) {
              flex: 1.1;
            }
            :nth-child(7) {
              flex: 1.1;
            }
            :nth-child(8) {
              flex: 1.1;
            }
            :nth-child(9) {
              flex: 1.1;
            }
            :nth-child(10) {
              flex: 0.9;
            }
          }
        }
      }
    }
    .query_page {
      width: 100%;
    }
    .page_active {
      // width: 76%;
      // width: 1152px;
      right: 0;
    }
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .query {
    min-width: 1680px;
    .query_nav {
      min-width: 1680px;
    }
    .query_seach {
      min-width: 1680px;
      ._searchKong {
        flex: 1;
      }
      ._seachLeft {
        flex: 1.7;
      }
      ._seachRight {
        flex: 0.9;
      }
    }
    .query_tabs {
      min-width: 1680px;
      ._tabsLeft {
        width: 268px;
      }
      ._tabsRight {
        width: 1392px;
        margin-left: 20px;
        ._tabsTop {
          ul {
            width: 1392px;
            li {
              padding: 0 5px 0 5px;
              box-sizing: border-box;
            }
            :nth-child(1) {
              flex: 1.3;
            }
            :nth-child(2) {
              flex: 1.3;
            }
            :nth-child(3) {
              flex: 1.3;
            }
            :nth-child(5) {
              flex: 1.1;
            }
            :nth-child(4) {
              flex: 1;
            }
            :nth-child(6) {
              flex: 0.8;
            }
            :nth-child(7) {
              flex: 0.8;
            }
            :nth-child(8) {
              flex: 0.8;
            }
            :nth-child(9) {
              flex: 0.8;
            }
            :nth-child(10) {
              flex: 0.8;
            }
          }
        }
        ._tabsbottom {
          width: 1392px;
          ul {
            width: 1392px;
            li {
              padding: 14px 5px 12px 5px;
              box-sizing: border-box;
            }
            :nth-child(1) {
              flex: 1.3;
            }
            :nth-child(2) {
              flex: 1.3;
            }
            :nth-child(3) {
              flex: 1.3;
            }
            :nth-child(5) {
              flex: 1.1;
            }
            :nth-child(4) {
              flex: 1;
            }
            :nth-child(6) {
              flex: 0.8;
            }
            :nth-child(7) {
              flex: 0.8;
            }
            :nth-child(8) {
              flex: 0.8;
            }
            :nth-child(9) {
              flex: 0.8;
            }
            :nth-child(10) {
              flex: 0.8;
            }
          }
        }
      }
    }
    .query_page {
      width: 100%;
    }
    .page_active {
      // width: 73.2%;
      // width: 1392px;
    }
  }
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.closeActive {
  // float: left;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  cursor: pointer;
  transform: rotate(-90deg);
}
.tips {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 400;
  color: #96a1ac;
}
.rollBox {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.query {
  width: 100%;
  // min-width: 1680px;
  background: #f3f5f9;
  position: relative;
  /deep/.el-loading-spinner {
    top: 30%;
  }
  .query_nav {
    // min-width: 1680px;
    height: 84px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 0px #96a1ac;
    ._navBox {
      display: flex;
      justify-content: center;
      padding-top: 18px;
      ._navleft {
        flex: 0.5;
        .img {
          width: 146px;
          height: 47px;
          margin-top: 20px;
        }
      }
      ._navRight {
        flex: 1;
        .right_tabs {
          overflow: hidden;
          ul {
            float: right;
            overflow: hidden;
            margin-right: 34px;
            li {
              float: left;
              padding: 0 22px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #000000;
              line-height: 51px;
              cursor: pointer;
            }
            :nth-child(2) {
              border-bottom: 6px solid #0087fa;
              padding-bottom: 10px;
            }
            li:hover {
              border-bottom: 6px solid #0087fa;
              padding-bottom: 10px;
            }
          }
        }
        .right_btn {
          margin-top: 7px;
          float: right;
          width: 120px;
          height: 36px;
          background: #0087fa;
          border-radius: 7px;
          font-size: 24px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #ffffff;
          line-height: 36px;
          // letter-spacing: 7px;
          text-align: center;
          cursor: pointer;
        }
        :nth-child(1) {
          margin-left: 12px;
        }
      }
    }
  }
  .ewmDialog {
    padding: 20px;
    width: 500px;
    height: 390px;
    background-color: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    text-align: center;
    .ewmFont {
      font-size: 18px;
      font-weight: 400;
      text-align: center;
    }
    img {
      margin-top: 10px;
    }
  }
  .query_bgc {
    width: 100%;
    height: 98px;
    background: linear-gradient(176deg, #0f81d9 0%, #071c76 100%);
    .query_seach {
      // min-width: 1680px;
      display: flex;
      justify-content: center;
      // align-items:center;
      padding-top: 25px;
      ._seachLeft {
        overflow: hidden;
        /deep/.el-input {
          float: left;
          width: 683px;
          height: 48px;
          .el-input__inner {
            height: 48px;
            line-height: 48px;
            border: 0;
            border-radius: 4px 0 0 4px;
          }
        }
        ._searchBtn {
          width: 48px;
          height: 48px;
          background: #fff;
          border-radius: 0px 4px 4px 0px;
          float: left;
          text-align: center;
          cursor: pointer;
          padding-top: 14px;
          box-sizing: border-box;
          img {
            width: 20px;
            height: 19px;
          }
          span {
            font-size: 20px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
      ._seachRight {
        overflow: hidden;
        .right_icon {
          float: right;
          line-height: 48px;
          .liulan {
            width: 21px;
            height: 16px;
            vertical-align: middle;
          }
          .fangwen {
            width: 17px;
            height: 17px;
            vertical-align: middle;
          }
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            vertical-align: middle;
          }
        }
        :nth-child(1) {
          margin-left: 12px;
        }
      }
    }
  }
  .query_tabs {
    // min-width: 1680px;
    display: flex;
    justify-content: center;
    margin-top: 44px;
    margin-bottom: 17px;
    ._tabsLeft {
      // width: 268px;
      position: relative;
      ._tabsTitle {
        padding: 0 24px;
        font-size: 14px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #677985;
        line-height: 21px;
        box-sizing: border-box;
        margin-bottom: 11px;
      }
      ._tabsTopBox {
        width: 100%;
        height: 650px;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
        padding: 22px 21px 22px 21px;
        box-sizing: border-box;
        position: relative;
        .topBox_title {
          position: absolute;
          font-size: 14px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #677985;
          line-height: 21px;
          margin-bottom: 10px;
        }
        .topBox_radio {
          position: absolute;
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 21px;
          margin-bottom: 10px;
          // 添加颜色类
          /deep/.el-radio__input.is-checked + .el-radio__label {
            color: #677985 !important;
          }
          /deep/.el-radio__input.is-checked .el-radio__inner {
            background: #677985 !important;
            border-color: #677985 !important;
          }
        }
        .topBox_radioTime {
          position: absolute;
          overflow: hidden;
          margin-bottom: 12px;
          /deep/.el-input {
            float: left;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #677985;
            line-height: 21px;
            width: 184px;
          }
          /deep/.el-input__inner {
            width: 95px;
            height: 36px;
            line-height: 36px;
            background: #ecf3f8;
            border: 0;
            border-radius: 0;
            padding-right: 0;
          }
          /deep/.el-input__prefix {
            top: -2px;
          }
        }
        .topBox_inp {
          position: absolute;
          overflow: hidden;
          margin-bottom: 12px;
          img {
            float: left;
            width: 36px;
            height: 36px;
            cursor: pointer;
          }
          .close {
            float: left;
            width: 36px;
            height: 36px;
            cursor: pointer;
            transform: rotate(-90deg);
          }
          /deep/.el-input {
            float: left;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #677985;
            line-height: 21px;
            width: 184px;
          }
          /deep/.el-input__inner {
            width: 184px;
            height: 36px;
            line-height: 36px;
            background: #ecf3f8;
            border: 0;
            border-radius: 0;
          }
          /deep/.el-input__prefix {
            top: -2px;
          }
        }
        .topBox_time {
          position: absolute;
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 21px;
          margin: 22px 0 10px 0;
        }
        .topBox_type {
          position: absolute;
          margin: 22px 0 10px 0;
          font-size: 14px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #677985;
          line-height: 21px;
        }
        .topBox_sub {
          position: absolute;
          right: 26px;
        }
        .topBox_zhu {
          position: absolute;
          margin-top: 12px;
          ._zhuTips {
            width: 220px;
            text-align: center;
            font-weight: 700;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            color: #677985;
            line-height: 17px;
          }
          ._zhuList {
            margin-top: 3px;
            ol {
              padding-right: 21px;
              margin-left: 10px;
              li {
                list-style: decimal;
                font-size: 14px;
                font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                font-weight: 700;
                color: #677985;
                line-height: 18px;
                margin-top: 10px;
                cursor: pointer;
                a {
                  font-size: 14px;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 700;
                  color: #677985;
                  line-height: 18px;
                  cursor: pointer;
                }
                a:hover {
                  color: #0087fa;
                }
              }
              li:first-child {
                  margin-top: 0;
              }
            }
          }
          ._zhuTishi {
            width: 220px;
            font-weight: 700;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            color: #677985;
            line-height: 17px;
            margin-top: 5px;
            cursor: pointer;
          }
        }
      }
      // 下拉框
      ._dialog {
        // width: 490px;
        // height: 133px;
        background: #ffffff;
        box-shadow: 0px 4px 14px 0px rgba(150, 161, 172, 0.74);
        opacity: 0.96;
        border: 1px solid rgba(209, 216, 222, 0.38);
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
        position: absolute;
        left: 24px;
        .jiao {
          position: absolute;
          top: -9px;
          left: 34px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #fff;
        }
        ._dialogBox {
          ul {
            overflow: hidden;
            li {
              // height: 36px;
              background: #ecf3f8;
              border-radius: 2px;
              text-align: center;
              font-size: 14px;
              font-family: SourceHanSansCN-Normal, SourceHanSansCN;
              font-weight: 400;
              color: #677985;
              padding: 12px 14px;
              box-sizing: border-box;
              float: left;
              margin-right: 16px;
              cursor: pointer;
              margin-bottom: 16px;
            }
            .active {
              color: #0087fa;
            }
          }
        }
      }
      // 右侧选择
      ._seltDialog {
        width: 550px;
        height: 683px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
        opacity: 0.99;
        position: absolute;
        top: 33px;
        left: 280px;
        border-radius: 5px;
        padding: 25px 30px;
        box-sizing: border-box;
        // 新版样式
        ._jiao {
          position: absolute;
          left: -10px;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-right: 10px solid #fff;
        }
        ._diaSeach {
          overflow: hidden;
          ._title {
            float: left;
            margin: 8px 10px 0 0;
            font-size: 16px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #677985;
          }
          /deep/.el-input {
            float: left;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #677985;
            line-height: 21px;
            width: 184px;
          }
          /deep/.el-input__inner {
            width: 100%;
            height: 36px;
            line-height: 36px;
            background: #ecf3f8;
            border: 0;
            border-radius: 0;
          }
          /deep/.el-input__prefix {
            top: -2px;
          }
          ._searchBtn {
            width: 36px;
            height: 36px;
            float: left;
            // margin-left: 16px;
            text-align: center;
            padding-top: 8px;
            background-color: #ecf3f8;
            box-sizing: border-box;
            cursor: pointer;
            img {
              width: 20px;
              height: 19px;
            }
          }
          .closeIcon {
            float: right;
            cursor: pointer;
          }
        }
        ._diaSeachBox {
          width: 100%;
          display: flex;
          margin-top: 29px;
          ._diaLeft {
            flex: 1;
            height: 562px;
            ._leftTitle {
              overflow: hidden;
              font-size: 14px;
              font-family: SourceHanSansCN-Bold, SourceHanSansCN;
              font-weight: bold;
              color: #677985;
              line-height: 21px;
              margin-bottom: 16px;
            }
            ._leftBox {
              ._leftOneFloor {
                width: 206px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                img {
                  width: 24px;
                  height: 24px;
                  vertical-align: middle;
                  cursor: pointer;
                }
                ._changeBox {
                  width: 24px;
                  height: 24px;
                  background: #ecf3f8;
                  border-radius: 3px;
                  display: inline-block;
                  vertical-align: middle;
                  cursor: pointer;
                  text-align: center;
                }
                span {
                  display: inline-block;
                  width: 110px;
                  vertical-align: middle;
                  font-size: 14px;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #677985;
                  line-height: 21px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                ._leftTweFloor {
                  margin-top: 16px;
                  margin-left: 24px;
                  img {
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    cursor: pointer;
                  }
                  span {
                    vertical-align: middle;
                    font-size: 14px;
                    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                    font-weight: 400;
                    color: #677985;
                    line-height: 21px;
                  }
                  ._leftTreeFloor {
                    margin-top: 16px;
                    margin-left: 52px;
                    ._changeBox {
                      width: 24px;
                      height: 24px;
                      background: #ecf3f8;
                      border-radius: 3px;
                      display: inline-block;
                      vertical-align: middle;
                      cursor: pointer;
                      text-align: center;
                    }
                    span {
                      vertical-align: middle;
                      font-size: 14px;
                      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                      font-weight: 400;
                      color: #677985;
                      line-height: 21px;
                      vertical-align: middle;
                    }
                  }
                }
              }
            }
          }
          ._diaRight {
            flex: 1;
            margin-left: 24px;
            height: 562px;
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
            ._leftTitle {
              font-size: 14px;
              font-family: SourceHanSansCN-Bold, SourceHanSansCN;
              font-weight: bold;
              color: #677985;
              line-height: 21px;
              margin-bottom: 22px;
            }
            ._rightOneFloor {
              // height: 475px;
              // overflow-y: auto;
              .floorTitle {
                font-size: 14px;
                font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                font-weight: 400;
                color: #677985;
                line-height: 21px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                i {
                  cursor: pointer;
                }
              }
              ._rightTweFloor {
                margin-left: 21px;
                margin-top: 22px;
              }
            }
            ._rightBtn {
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
    ._tabsRight {
      // width: 1392px;
      flex: 1;
      // margin-left: 20px;
      position: relative;
      ._tabsTop {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 11px;
        ._tabsChioce {
          display: flex;
          width: 85px;
          align-items: center;
          justify-content: center;
          ._changeBox {
            width: 20px;
            height: 20px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid rgba(103, 121, 133, 0.5);
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            text-align: center;
          }
          span {
            font-size: 14px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #677985;
            line-height: 21px;
            margin-left: 5px;
          }
        }
        ._tabsIndex {
          // width: 36px;
          height: 22px;
        }
        ul {
          // width: 1392px;
          flex: 1;
          display: flex;
          justify-content: space-around;
          align-items: center;
          li {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #677985;
            line-height: 21px;
            cursor: default;
            div {
              // margin-top: 3px;
              // float: right;
              display: inline-block;
              line-height: 10px;
              vertical-align: middle;
              icon {
                display: flex;
                align-content: stretch;
                line-height: 0.5;
              }
              .upIcon {
                color: #0087fa;
              }
              .downIcon {
                color: #0087fa;
              }
            }
          }
        }
        ._tabsBtn {
          width: 101px;
          height: 22px;
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        }
      }
      ._kongbai {
        min-height: 683px;
        ._kong {
          margin-top: 200px;
          text-align: center;
          img {
            width: 279px;
            height: 191px;
          }
          div {
            text-align: center;
          }
        }
      }
      ._tabsbottom {
        display: flex;
        justify-content: space-around;
        // align-items: center;
        // width: 1392px;
        background: #ffffff;
        border-radius: 3px;
        margin-bottom: 6px;
        ._tabsChioce {
          display: flex;
          width: 51px;
          align-items: center;
          justify-content: center;
          ._changeBox {
            width: 20px;
            height: 20px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid rgba(103, 121, 133, 0.5);
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            text-align: center;
          }
        }
        ._tabsIndex {
          width: 36px;
          background: #0087fa;
          border-radius: 3px 0px 0px 3px;
          text-align: center;
          font-size: 18px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        ul {
          // width: 1392px;
          flex: 1;
          display: flex;
          justify-content: space-around;
          align-items: center;
          li {
            flex: 1;
            text-align: center;
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #677985;
          }
        }
        ._tabsBtn {
          width: 101px;
          background: #d1d8de;
          border-radius: 0px 3px 3px 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        }
      }
      ._tabsbottom:hover {
        cursor: pointer;
        box-shadow: 0px 3px 9px 0px rgba(0, 135, 250, 0.38);
        ul {
          li {
            font-size: 14px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #0087fa;
          }
        }
        ._tabsBtn {
          background: #0087fa;
        }
      }
      ._tabsBottomBox {
        margin-top: 10px;
        width: 100%;
        background: #d1d8de;
        // border-radius: 6px 6px 0 0;
        padding: 5px 21px 22px 21px;
        box-sizing: border-box;
        ._tabsUp {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 20px;
        }
        ._tabsBottom {
          margin-top: 10px;
          font-size: 12px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #677985;
          line-height: 20px;
        }
      }
    }
  }
  .query_page {
    height: 48px;
    float: right;
    padding-top: 10px;
    box-sizing: border-box;
    // position: absolute;
    // bottom: 0;
    .query_export {
      overflow: hidden;
      float: left;
      .export {
        width: 126px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        line-height: 30px;
        float: left;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
        span {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #0087fa;
          vertical-align: middle;
        }
      }
      .exportChange {
        width: 126px;
        height: 32px;
        // background: #ffffff;
        border-radius: 4px;
        line-height: 30px;
        color: #0087fa;
        font-weight: 700;
        float: left;
        text-align: center;
        margin-right: 20px;
      }
    }
    /deep/.el-pagination {
      float: right;
      .el-pager li {
        font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #8996a0;
        line-height: 28px;
        width: 28px;
        height: 28px;
        background: #ffffff;
        border-radius: 3px;
      }
      .btn-next {
        width: 56px;
        height: 28px;
        background: #ffffff;
        line-height: 28px;
      }
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #a4c7ff;
      color: #fff;
    }
  }
  .page_active {
    background: rgba(103, 121, 133, 0.6);
    position: fixed;
    bottom: 0px;
    height: 48px;
    float: right;
    padding-top: 10px;
    box-sizing: border-box;
    .query_export {
      overflow: hidden;
      float: left;
      opacity: 1;
      margin-left: 90px;
      .export {
        width: 126px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        line-height: 30px;
        float: left;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 14px;
          height: 14px;
          vertical-align: middle;
        }
        span {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #0087fa;
          vertical-align: middle;
        }
      }
      .exportChange {
        width: 126px;
        height: 32px;
        // background: #ffffff;
        border-radius: 4px;
        line-height: 30px;
        color: #fff;
        font-weight: 700;
        float: left;
        text-align: center;
        margin-right: 20px;
      }
    }
    /deep/.el-pagination {
      float: right;
      .el-pager li {
        font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #8996a0;
        line-height: 28px;
        width: 28px;
        height: 28px;
        background: #ffffff;
        border-radius: 3px;
      }
      .btn-next {
        width: 56px;
        height: 28px;
        background: #ffffff;
        line-height: 28px;
      }
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #a4c7ff;
      color: #fff;
    }
  }
  .query_footer {
    width: 100%;
    height: 168px;
    background: #677985;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .footerBox {
      display: flex;
      align-items: center;
      justify-content: center;
      .footer_img {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 146px;
          height: 47px;
        }
      }
      .footer_conter {
        flex: 1;
        ._conterTop {
          font-size: 14px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #ffffff;
          line-height: 21px;
        }
        ._conterCet {
          ul {
            overflow: hidden;
            li {
              float: left;
              margin-right: 32px;
              a {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 17px;
              }
            }
          }
        }
      }
      .footer_right {
        flex: 1;
        padding-left: 77px;
        box-sizing: border-box;
        div {
          font-size: 12px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
// .msg-pagination-container.is-background .el-pager li {
//   /*对页数的样式进行修改*/
//   background-color: #10263c;
//   color: #FFF;
// }
// .msg-pagination-container.is-background .btn-next {
//   /*对下一页的按钮样式进行修改*/
//   background-color: #10263c;
//   color: #FFF;
// }
// .msg-pagination-container.is-background .btn-prev {
//   /*对上一页的按钮样式进行修改*/
//   background-color: #10263c;
//   color: #FFF;
// }
// .msg-pagination-container.is-background .el-pager li:not(.disabled).active {
//   /*当前选中页数的样式进行修改*/
//   background-color: #446cff;
//   color: #FFF;
// }
</style>


// WEBPACK FOOTER //
// src/views/query/query.vue